import _ from 'lodash';

/**
 * Returns endpoint types from which the current agent can receive inbound communications via routing groups
 *
 * @param { channelConfiguration, communicationQueues, currentAgent, routingGroups } - stores / providers
 * @returns {Array} of EndpointTypes
 */
export function getAgentChannels({ channelConfiguration, communicationQueues, currentAgent, routingGroups }) {
  let currentAgentId = _.get(currentAgent.get(), 'id');
  let agentRoutingGroups =
    routingGroups.findAll({ filter: rg => _.includes(rg.agentIds, currentAgentId), select: ['id'] }) || [];
  let routingGroupIds = _.map(agentRoutingGroups, 'id');

  let agentCommQueues = communicationQueues.findAll({
    filter: commQueue => _.includes(routingGroupIds, commQueue.routingGroupId),
  });
  let endpoints = _.get(channelConfiguration.get(), 'endpoints', []);
  let currentAgentEndpoints = _.chain(agentCommQueues)
    .map(commQueue => _.find(endpoints, endpoint => endpoint.id === commQueue.endpointId))
    .value();

  return _.uniq(_.map(currentAgentEndpoints, 'type'));
}

/**
 * Returns providers necessary to determine agent channels / endpoints
 *
 * @param getProvider - function to acquire a provider by name
 * @returns { channelConfiguration, communicationQueues, currentAgent, routingGroups }
 */
export function getAgentChannelProviders(getProvider) {
  return ['channelConfiguration', 'communicationQueues', 'currentAgent', 'routingGroups'].reduce(
    (memo, name) => _.assign(memo, { [name]: getProvider(name) }),
    {}
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/page_layout/lib/agent_channels.js